import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { Revision } from 'types'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { reportError } from 'utils/error'

interface Props {
  articleKey: string
  layerId: string
  id: string
}

export interface Data {
  revision: Revision
}

export type Options = Omit<UseMutationOptions<Data, unknown>, 'mutationKey' | 'mutationFn'>

export const discardAIRevision = async ({ articleKey, layerId, id }: Props) => {
  const response = await sendToApi<Data>(`/articles/${articleKey}/layers/${layerId}/ai_revisions/${id}/discard`, {
    method: 'POST',
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError(response)
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }

  return response
}

export const useDiscardRevision = (props: Props, options?: Options) => {
  return useMutation<Data, unknown>(
    async () => {
      const response = await discardAIRevision({ ...props })
      return response.data
    },
    {
      ...options,
    },
  )
}
